import { render, staticRenderFns } from "./OnboardingThreeOptions.vue?vue&type=template&id=a96c3a30&scoped=true"
import script from "./OnboardingThreeOptions.vue?vue&type=script&lang=js"
export * from "./OnboardingThreeOptions.vue?vue&type=script&lang=js"
import style0 from "./OnboardingThreeOptions.vue?vue&type=style&index=0&id=a96c3a30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96c3a30",
  null
  
)

export default component.exports